var LogBox={ignoreLogs(){},ignoreAllLogs(){},uninstall(){},install(){}};export default LogBox;